<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>


export default {
 
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
}
body{
  padding:0px;
  margin:0px;
}

:root {
    --primary-color: #2563eb;
    --secondary-color: #3b82f6;
    --bg-color: #f8fafc;
    --card-bg: #ffffff;
    --text-color: #334155;
    --border-color: #e2e8f0;
    --section-bg: #f1f5f9;
    --footer-bg: #1e293b;
    --footer-text: #cbd5e1;
    --highlight-color: #dbeafe;
    --shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    --transition: all 0.3s ease;
}
.dark-mode {
    --primary-color: #60a5fa;
    --secondary-color: #93c5fd;
    --bg-color: #0f172a;
    --card-bg: #1e293b;
    --text-color: #e2e8f0;
    --border-color: #334155;
    --section-bg: #1e293b;
    --footer-bg: #0f172a;
    --footer-text: #94a3b8;
    --highlight-color: #1e3a8a;
    --shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}


/* App.vue 或全局 CSS 文件 */

@media (max-width: 768px) {
  .header-content h1 {
    font-size: 20px;
  }

  .policy-card {
    padding: 20px;
  }

  .sdk-table th,
  .sdk-table td {
    padding: 8px 10px;
  }

  .policy-card h2 {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .header-content h1 {
    font-size: 17px;
  }

  .meta-info {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .sdk-table {
    display: block;
    overflow-x: auto;
  }
}
</style>
